import moment from 'moment'

export default {

  formData(data) {
    let formData = new FormData()
    Object.keys(data).forEach(key => {
      const val = data[key]
      console.log(key, val)
      if (val != null) formData.append(key, val);
    });
    return formData
  },

  filterNull(data) {
    let dic = {}
    Object.keys(data).forEach(key => {
      const val = data[key]
      if (!!val) dic[key] = val;
    });
    return dic
  },

  formatDBDate(date) {
    if (!date)
    return;

    return moment(date).format('YYYY-MM-DD');
  },

  isPhoto (name) {
    return /\.(jpe?g|png|gif)$/i.test(name)
  },

  isMovie (name) {
    return /\.(avi|mpg|mp4|ogg|mov)$/i.test(name)
  },

  formatChatTime(date){
    if(!date)
      return;

    return moment(date).format('MM/DD HH:mm');
  },

  animateScroll(duration, someElement) {
    var start = someElement.scrollTop;
    var end = someElement.scrollHeight;
    var change = end - start;
    var increment = 20;

    function easeInOut(currentTime, start, change, duration) {
      // by Robert Penner
      currentTime /= duration / 2;
      if (currentTime < 1) {
        return change / 2 * currentTime * currentTime + start;
      }
      currentTime -= 1;
      return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
    }
    function animate(elapsedTime) {
      elapsedTime += increment;
      var position = easeInOut(elapsedTime, start, change, duration);
      someElement.scrollTop = position;
      if (elapsedTime < duration) {
        setTimeout(function() {
          animate(elapsedTime);
        }, increment)
      }
    }
    animate(0); 
  }
}